import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import constants from '../../config/constants'
import { request } from '../../_network/request'
import { docsURLs } from '../../_network/apiUrls'
import { sortByPriority } from '../subscriptions/_helpers/sort'
import DocsTopicItem from './DocsTopicItem'

const DocsCatalogItem = (props) => {
  const { name, display_name, expandedPanelName, expandedSubPanelName } = props
  const theme = useTheme()

  const [docs, setDocs] = useState([])
  const [expandedPanel, setExpandedPanel] = useState('')

  const arrowStyle = {
    color: theme.palette.violetsAreBlue,
    fontSize: '36px',
  }

  const accordionStyle = {
    background: 'none',
    boxShadow: 'none',
  }

  const accordionSummaryStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '18px',
    fontWeight: '500',
    borderBottom: `${theme.palette.grayX11} 1px solid`,
  }

  const handleChangeExpandedPanel = (panel) => (event, newExpanded) => {
    setExpandedPanel(newExpanded ? panel : false)
  }

  useEffect(() => {
    const fetchDocsData = async () => {
      const url = constants.core_service_domain + '/' + docsURLs.getDocs + '?catalog_item=' + name
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setDocs(sortByPriority(response.data))
      } else {
        setDocs([])
      }
    }

    if (expandedPanel === name) {
      fetchDocsData()
    } else {
      setDocs([])
    }    
  }, [name, expandedPanel])

  useEffect(() => {
    setExpandedPanel((expandedPanelName && name === expandedPanelName) ? name : '')
  }, [name, expandedPanelName])
  
  return (
    <Accordion
      expanded={expandedPanel === name}
      onChange={handleChangeExpandedPanel(name)}
      id={`section-${name}`}
      sx={accordionStyle}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon sx={arrowStyle} />}
        sx={accordionSummaryStyle}
      >
        <Box>{display_name}</Box>     
      </AccordionSummary>
      <AccordionDetails>      
        {
          docs.map((item, index) => (
            <DocsTopicItem
              key={index}
              {...item}
              expandedSubPanelName={expandedSubPanelName}
            />
          ))
        }
      </AccordionDetails>
    </Accordion>
  )
}

export default DocsCatalogItem